export default __webpack_public_path__ + "static/media/firstStep.c5e83e2b.jpg";